import "./App.css";
import AppRouting from "./appRouting/index";
import { ToastContainer } from "react-toastify";
function App() {

  return (
    <>
      <ToastContainer />
      <AppRouting />
    </>
  );
}

export default App;
